import React, { useState } from "react";

type Props = {
  modeloOpcao: {
    id: number;
    descricao: string;
    tipo: 'unica' | 'multipla';
    obrigatorio: boolean;
  };
  opcoesRespostas: {
    id?: number;
    modelo_opcao_item_id: number;
    marcado: boolean;
    resposta_texto?: string;
    modelo_opcao_item: {
      id: number;
      descricao: string;
      texto_obrigatorio: boolean;
      ordem: number;
    }
  }[];
  disabled: boolean;
}

export function FormRelatorioModeloOpcao({ modeloOpcao, opcoesRespostas: opcoesRespostasProp, disabled }: Props): JSX.Element {
  const [opcoesRespostas, setOpcoesRespostas] = useState(opcoesRespostasProp);

  const onCheck = (opcaoResposta: Props['opcoesRespostas'][number]) => {
     setOpcoesRespostas(opcoesRespostas.map((item) => {
        const isOpcao = item.id == opcaoResposta.id && opcaoResposta.modelo_opcao_item_id == item.modelo_opcao_item_id;
        let marcado = item.marcado;
        if(modeloOpcao.tipo == 'multipla' && isOpcao) {
          marcado = !opcaoResposta.marcado;
        }else if(modeloOpcao.tipo == 'unica') {
          marcado = isOpcao ? !opcaoResposta.marcado : !!opcaoResposta.marcado;
        }

        return {
          ...item,
          marcado,
          resposta_texto: marcado ? item.resposta_texto : undefined
        }
     }, [] as Props['opcoesRespostas']))
  }


  return (
    <div>
      <p className="grid-12">
        <strong>{modeloOpcao.descricao}</strong>
      </p>
      {opcoesRespostas.map((opcaoResposta, index) => {
        return (
          <React.Fragment key={index}>
            {!!opcaoResposta.id && (<input type="hidden" name={`relatorio[modelo_opcoes_itens_respostas_attributes[][id]]`} value={opcaoResposta.id} />)}
            <input type="hidden" name={`relatorio[modelo_opcoes_itens_respostas_attributes[][modelo_opcao_item_id]]`} value={opcaoResposta.modelo_opcao_item_id} />
            <input type="hidden" name={`relatorio[modelo_opcoes_itens_respostas_attributes[][marcado]]`} value={opcaoResposta.marcado.toString()} />

            <label className="form">
              <input
                type={modeloOpcao.tipo == 'unica' ? 'radio' : 'checkbox'}
                value={opcaoResposta.marcado.toString()}
                checked={opcaoResposta.marcado}
                disabled={disabled}
                onChange={() => {
                  onCheck(opcaoResposta)
                }}
              />
              <span className="label">
                {opcaoResposta.modelo_opcao_item.descricao}
              </span>
            </label>

            {opcaoResposta.modelo_opcao_item.texto_obrigatorio && opcaoResposta.marcado &&  (
              <label className="grid-12 form">
                <textarea
                  defaultValue={opcaoResposta.marcado ? opcaoResposta.resposta_texto || undefined : ""}
                  name='relatorio[modelo_opcoes_itens_respostas_attributes[][resposta_texto]]'
                  disabled={disabled || !opcaoResposta.marcado}
                  required
                ></textarea>
              </label>
            )}
          </React.Fragment>
        );
      })}
    </div>
  )
}